import {Variation} from '@sportngin/se-commerce-sdk/models/clare';
import {Product} from '../../../models/clare';

export function countActiveBundleProducts(products: Product[] | null | undefined): number {
  return (products ?? []).filter(product => product?.active === true).length;
}

export function hasActiveVariations(
  source: {variations?: Pick<Variation, 'active' | 'name'>[]} | null | undefined
): boolean {
  return Boolean(
    source?.variations?.filter(variation => variation.name !== 'Default').some(variation => variation.active)
  );
}

export function canBundleBeActive(
  bundleName: string | null | undefined,
  products: Product[] | null | undefined
): boolean {
  const bundleProducts = products ?? [];

  return (
    Boolean(bundleName?.trim()) &&
    bundleProducts.length >= 2 &&
    countActiveBundleProducts(bundleProducts) === bundleProducts.length
  );
}
